import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseDialogComponent } from '../base-dialog/base-dialog.component';
import { DxListComponent, DevExtremeModule } from 'devextreme-angular';

@Component({
    selector: 'app-search-dialog',
    standalone: true,
    imports: [DevExtremeModule],
    templateUrl: './search-dialog.component.html',
    styleUrls: ['./search-dialog.component.scss']
})
export class SearchDialogComponent extends BaseDialogComponent<any> implements OnInit {
    items: any[];
    selectedItem: any;
    allowClear = false;
    @ViewChild('list') list: DxListComponent;

    ngOnInit() {
        setTimeout(() => this.list.instance.focus());
    }

    select = () => {
        this.hide(this.list.selectedItems[0]);
    };

    cancel = () => {
        this.hide(null);
    };

    clear = () => {
        this.hide('_CLEAR_');
    };
}
